import {
  takeLatest,
  call,
  put,
  all,
  delay,
  race,
  take,
  select,
} from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '../../../services/api';
import history from '../../../services/history';
import { updateStatus, resetMigration, startPolling } from './actions';
import { canAccessMigration } from '../../../utils/migration';

const POLL_INTERVAL_MS = 3000;

const MAX_CONSECUTIVE_ERRORS = 10;

function* pollLoop() {
  yield race([
    call(function* poll() {
      let errorCount = 0;
      while (true) {
        try {
          const response = yield call(api.get, '/migration/status');
          const { data } = response;
          errorCount = 0;
          yield put(updateStatus(data));

          if (data.status === 'COMPLETED' || data.status === 'FAILED') {
            history.push('/migration');
            return;
          }
        } catch (err) {
          if (err.response && err.response.status === 404) {
            yield put(resetMigration());
            return;
          }
          errorCount += 1;
          if (errorCount >= MAX_CONSECUTIVE_ERRORS) {
            yield put(resetMigration());
            return;
          }
        }
        yield delay(POLL_INTERVAL_MS);
      }
    }),
    take('@migration/STOP_POLLING'),
    take('@auth/SIGN_OUT'),
  ]);
}

function* handleStartMigration() {
  const profile = yield select(state => state.user.profile);
  if (!canAccessMigration(profile)) return;

  try {
    yield call(api.post, '/migration/start');
    toast.success('Migracao iniciada!');
    yield put(startPolling());
  } catch (err) {
    const errorMsg = err.response?.data?.error || 'Erro ao iniciar migracao';

    if (errorMsg.includes('already')) {
      yield put(startPolling());
    } else {
      toast.error(errorMsg);
    }
  }
}

function* handleRetryMigration() {
  const profile = yield select(state => state.user.profile);
  if (!canAccessMigration(profile)) return;

  try {
    yield call(api.post, '/migration/retry');
    toast.success('Tentando novamente...');
    yield put(startPolling());
  } catch (err) {
    toast.error(err.response?.data?.error || 'Erro ao tentar novamente');
  }
}

function* checkMigrationOnRehydrate({ payload }) {
  if (!payload || !payload.auth || !payload.auth.token) return;

  const profile = payload.user?.profile;
  if (!canAccessMigration(profile)) return;

  try {
    const response = yield call(api.get, '/migration/status');
    const { data } = response;
    yield put(updateStatus(data));

    if (
      data.status === 'IN_PROGRESS' ||
      data.status === 'RETRYING' ||
      data.status === 'PENDING'
    ) {
      yield put(startPolling());
    }
  } catch (err) {
    if (err.response && err.response.status === 404) {
      yield put(resetMigration());
    }
  }
}

export default all([
  takeLatest('persist/REHYDRATE', checkMigrationOnRehydrate),
  takeLatest('@migration/START_MIGRATION', handleStartMigration),
  takeLatest('@migration/RETRY_MIGRATION', handleRetryMigration),
  takeLatest('@migration/START_POLLING', pollLoop),
]);
